import DataLayerBaseEvent from './DataLayerBaseEvent';
export default class BaseEventNoPayload extends DataLayerBaseEvent {
    update(tms, payload, errorHandler) {
        this.updateDataLayer(tms, this.tmsEventType, this.eventName, {}, errorHandler);
    }
}
//# sourceMappingURL=BaseEventNoPayload.js.map